import {
  Package,
  GraduationCap,
  Scale,
  TrendingUp,
  Handshake,
  Compass,
  ShieldCheck,
  Target,
  Lightbulb,
  Globe,
} from "lucide-react";

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const services = [
  {
    id: "export-import",
    icon: Package,
    title: "Export / Import",
    description:
      "Specialized in bulk drugs for the pharma sector and recyclable plastic resin materials, facilitating seamless international trade.",
    features: [
      "Pharma sector trade",
      "Recyclable plastic resin materials",
      "Trade documentation",
      "Supply chain optimization",
    ],
  },
  {
    id: "human-capital",
    icon: GraduationCap,
    title: "Human Capital Development",
    description:
      "Technical skill development and training programs to build workforce capabilities.",
    features: [
      "Skill development programs",
      "Technical training",
      "Workforce capability building",
      "Leadership development",
    ],
  },
  {
    id: "trade-consulting",
    icon: Scale,
    title: "International Trade Consulting",
    description:
      "Navigate complex global trade regulations and expand your business across borders. We provide comprehensive guidance on import/export regulations, tariffs, and compliance requirements.",
    features: [
      "Trade compliance audits",
      "Customs regulations guidance",
      "Export documentation",
      "Tariff classification",
    ],
  },
  {
    id: "business-development",
    icon: TrendingUp,
    title: "Business Development",
    description:
      "Strategic planning and market entry strategies tailored for US, India, and Latin American markets. We help you identify opportunities and develop actionable growth plans.",
    features: [
      "Market research & analysis",
      "Business plan development",
      "Growth strategy consulting",
      "Competitive analysis",
    ],
  },
  {
    id: "partnership",
    icon: Handshake,
    title: "Partnership Facilitation",
    description:
      "Connect with the right partners and build lasting business relationships across continents. Our network spans manufacturers, distributors, and service providers worldwide.",
    features: [
      "Partner identification",
      "Due diligence support",
      "Negotiation assistance",
      "Relationship management",
    ],
  },
  {
    id: "market-entry",
    icon: Compass,
    title: "Market Entry Strategy",
    description:
      "Comprehensive support for entering new markets including regulatory compliance, local partnerships, and operational setup.",
    features: [
      "Market feasibility studies",
      "Regulatory compliance",
      "Local entity setup",
      "Cultural consulting",
    ],
  },
];

export const whyChoose = [
  {
    icon: ShieldCheck,
    title: "Trusted Expertise",
    description:
      "Decades of combined experience in international trade and business development.",
  },
  {
    icon: Target,
    title: "Results-Driven",
    description:
      "Focused on delivering measurable outcomes that drive your business growth.",
  },
  {
    icon: Lightbulb,
    title: "Innovative Solutions",
    description:
      "Creative approaches to complex challenges in global commerce.",
  },
  {
    icon: Globe,
    title: "Our Global Reach",
    description:
      "US Market Entry & Compliance, India Manufacturing & IT Partnerships, Latin America Trade & Distribution.",
  },
];

export const globalReach = [
  {
    region: "United States",
    focus: "Market Entry & Compliance",
    description:
      "Navigating US regulations, compliance frameworks, and establishing a strong market presence.",
  },
  {
    region: "India",
    focus: "Manufacturing & IT Partnerships",
    description:
      "Connecting with leading manufacturers and technology partners across India.",
  },
  {
    region: "Latin America",
    focus: "Trade & Distribution",
    description:
      "Building distribution networks and trade relationships across Latin American markets.",
  },
];

export const stats = [
  { value: "3", label: "Continents Served" },
  { value: "20+", label: "Years Experience" },
  { value: "100+", label: "Partnerships Built" },
  { value: "6", label: "Core Services" },
];

export const contactInfo = {
  email: "info@Jlaconsultantsllc.com",
  phone: "571-639-8282",
  location: "Global Operations",
};

export const company = {
  name: "JLa Consultants LLC",
  tagline:
    "Your trusted consulting partner for international trade and development across US, India, and Latin America.",
};
